import React, { Suspense } from 'react';
import { ThemeProvider } from 'styled-components';
// import { saTheme } from '@bit/livingpackets.frontend-react.sa20.sa-theme';
import { saTheme } from './../../configs/sa-theme';

const Graph = React.lazy(() => import('./components/Graph'));

const Entrypoint = () => {
  return (
    <Suspense fallback={null}>
      <ThemeProvider theme={saTheme}>
        <Graph />
      </ThemeProvider>
    </Suspense>
  );
};

export default Entrypoint;
